import type { Db } from "@/db";
import { badgeDefinitions } from "@/db/schema";
import {
  pickTieredBadges as _pickTieredBadges,
  COMPETITION_BADGE_COUNT,
} from "@/features/badges/utils";

export { COMPETITION_BADGE_COUNT };

export interface BadgeData {
  id: string;
  name: string;
  description: string;
  iconEmoji: string;
  stepThreshold: number;
  tier: string;
}

// ─── DB access ───────────────────────────────────────────────────────────────

export async function getAllBadgeDefinitions(db: Db): Promise<BadgeData[]> {
  return db.select().from(badgeDefinitions).orderBy(badgeDefinitions.stepThreshold);
}

// ─── Pure helpers (no DB dependency — pass badge data directly) ──────────────

export function getBadgeById(id: string, allBadges: BadgeData[]): BadgeData | undefined {
  return allBadges.find((b) => b.id === id);
}

export function getQualifyingBadges(totalSteps: number, allBadges: BadgeData[]): BadgeData[] {
  return allBadges
    .filter((b) => b.stepThreshold <= totalSteps)
    .sort((a, b) => a.stepThreshold - b.stepThreshold);
}

export const pickTieredBadges = _pickTieredBadges<BadgeData>;

export function validateBadgeIds(
  ids: string[],
  allBadges: BadgeData[],
  maxThreshold?: number,
): boolean {
  if (ids.length !== COMPETITION_BADGE_COUNT) return false;
  const badgeMap = new Map(allBadges.map((b) => [b.id, b]));
  return ids.every((id) => {
    const badge = badgeMap.get(id);
    if (!badge) return false;
    if (maxThreshold && badge.stepThreshold > maxThreshold) return false;
    return true;
  });
}
